import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUTMParams } from "@/lib/utm";

/**
 * Captures UTM params on every route change (including initial load).
 * Mount once at the root layout.
 */
export function UTMTracker() {
  const location = useLocation();
  useEffect(() => {
    captureUTMParams();
  }, [location.search, location.pathname]);
  return null;
}

export default UTMTracker;
